// extracted by mini-css-extract-plugin
export default {"fullPage":"FullPage_fullPage__Q1mhN"};